var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',[(_vm.hiddenImg!=true)?_c('el-col',{attrs:{"span":3}},[_c('img',{attrs:{"src":require("../../../../../assets//img/product/item-icon.png")}})]):_vm._e(),_c('el-col',{attrs:{"span":21}},[_vm._v("\n            "+_vm._s(_vm.content)+"\n        ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }